<template>
  <div class="lcu-page">
    <section class="section">
      <annoucement-banner />
      <page-legend
        :loading="programLoading || userLoading"
        :breadcrumbs="[
        { link: '/programas', text: 'Todos los programas' },
        { text: program.degree + ' en ' + program.name },
        ]"/>
    </section>
    <div class="lcu-program-section" v-if="!programLoading && !userLoading && !programLoadError">
      <div class="lcu-program-grid">
        <program-side-bar
          v-if="user.programs?.[program.slug]"
          @on-module-click="onModuleClick"
          :active-module="activeModule"
          :user-data="user"
          :program="program"
          :sections="program.sections || []" />
        <div
          :class="{
            'lcu-active-error': itemError
          }"
          class="lcu-active-section">
          <div class="lcu-active-paper" v-if="!itemError && !gatedForBilling">
            <div v-if="completedMessage">
              <p class="lcu-cert-image">
                <img src="/assets/certificate.svg" alt="Certificado de conclusión del programa" />
              </p>
              <header class="lcu-completed-header">
                ¡Has completado con éxito el programa de {{ program.degree }} en {{ program.name }}!
              </header>
              <p class="lcu-complete-p">
                Seguirás teniendo acceso al material de este programa haciendo clic en cualquier
                sección del menú lateral.
              </p>
            </div>
            <div
              v-if="!itemLoading
                && (activeContent || activeMedia)
                && !completedMessage && !activeExam">
              <div class="col-grid-3 lcu-media-header">
                <div />
                <div class="row row-center">
                  <span v-if="meta[getLearnPrefData.totalItems] > 1">
                    {{ getLearnPrefData.type }} {{ meta[getLearnPrefData.lastViewed] }} de
                    {{ meta[getLearnPrefData.totalItems] }}
                  </span>
                </div>
                <div class="lcu-media-btn">
                  <button-cta
                    v-if="activeContent"
                    :text="'Escuchar'"
                    :classes="['lcu-audio-btn']"
                    border
                    @on-click="mediaPlayerOpen = true" />
                </div>
              </div>
              <div class="row row-center" v-if="activeModule && activeMedia">
                <span class="lcu-media-title">
                  {{ activeModule.title }}
                </span>
              </div>
              <div class="row" v-if="activeContent && !activeMedia">
                <iframe
                  class="lcu-embed-pdf"
                  :src="activeContent"
                  allowfullscreen />
              </div>
              <div class="row" v-if="!activeContent && activeMedia">
                <AudioPlayer
                  @on-ready="() => {}"
                  :options="{
                    controls: true,
                    height: 350,
                    poster: '/assets/video-thumb.png',
                    sources: [
                      {
                        src: activeMedia,
                        type: 'audio/mpeg'
                      }
                    ]
                  }" />
              </div>
              <StickyElement
                v-if="meta[getLearnPrefData.totalItems] > 1"
                :sticky-class="'lcu-sticky-buttons'"
                :sticky-threshold="40"
                :release-threshold="80">
                <div class="row lcu-sticky-buttons">
                  <div class="lcu-multiPage-grid">
                    <div>
                      <button-cta
                        v-if="meta[getLearnPrefData.lastViewed] > 1"
                        :text="'Anterior ' + getLearnPrefData.type"
                        :loading="itemLoading"
                        :classes="['lcu-prev-btn']"
                        border
                        @on-click="onBackPageClick" />
                    </div>
                    <div />
                    <div>
                      <button-cta
                        v-if="meta[getLearnPrefData.lastViewed] < meta[getLearnPrefData.totalItems]"
                        :text="'Siguiente ' + getLearnPrefData.type"
                        :loading="itemLoading"
                        :classes="['lcu-next-btn']"
                        @on-click="onNextPageClick" />
                      <button-cta
                        v-if="
                          meta[getLearnPrefData.lastViewed] === meta[getLearnPrefData.totalItems] &&
                          // eslint-disable-next-line max-len
                          !user.programs[program.slug]?.sections[activeSection.id]?.modules[activeModule.id]?.progress?.completed"
                        :text="activeModule.exam ? 'Guardar e ir al examen' : 'Guardar y completar'"
                        :loading="itemLoading"
                        :classes="['lcu-complete-btn']"
                        @on-click="onCompleteClick" />
                    </div>
                  </div>
                </div>
              </StickyElement>
            </div>
            <div v-if="activeExam">
              <div class="lcu-exam-container">
                <div class="row row-center">
                  <header class="lcu-h2">
                    Examen - {{ activeModule?.title }}
                  </header>
                </div>
                <div class="row">
                  <div
                    class="row lcu-question-wrapper"
                    :class="{
                      'lcu-question-wrong': incorrect[item.id]
                    }"
                    v-for="(item, index) in activeExam.questions" :key="item.id">
                    <div class="lcu-exam-question">
                      <span class="lcu-question-number">{{ index + 1 }}.)</span> {{ item.question }}
                    </div>
                    <div class="lcu-exam-option" v-for="option in item.options" :key="option.id">
                      <div class="lcu-radio-field">
                        <input
                          :id="option.id"
                          class="lcu-radio-input"
                          :name="option.value"
                          :value="option.id"
                          v-model="activeExamAnswers[item.id]"
                          :disabled="examGrade"
                          @change="onAnswerSelect"
                          type="radio" />
                        <label
                          :for="option.id"
                          class="lcu-radio-label">{{ option.value }}</label>
                      </div>
                    </div>
                    <div
                      class="row lcu-failed-msg"
                      v-if="incorrect[item.id]">
                      Respuesta Incorrecta
                    </div>
                  </div>
                </div>
                <div
                  class="row row-center lcu-exam-statusWrapper"
                  ref="examResults"
                  id="examResults"
                  :class="{
                    'lcu-exam-passed': examStatus === 'passed',
                    'lcu-exam-failed': examStatus === 'failed'
                  }"
                  v-show="examStatus === 'passed' || examStatus === 'failed'">
                  <div class="lcu-exam-score">Calificación: <span>{{ examGrade }}</span></div>
                  <div class="lcu-exam-status">Estatus: <span>{{ examStatus }}</span></div>
                  <div class="lcu-retake-btn">
                    <button-cta
                      v-if="examStatus === 'failed'"
                      :text="'Volver a tomar el examen ahora'"
                      @on-click="confirmRetake = true" />
                    <button-cta
                      v-if="examStatus === 'passed'"
                      :text="'Ir a la siguiente sección'"
                      :classes="['lcu-next-btn']"
                      @on-click="confirmNextSection = true" />
                  </div>
                  <p class="lcu-ask-p" v-if="examStatus === 'failed'">
                    ¿Necesitas ayuda?
                    <a href="mailto:professor@universidadlegacy.com" class="lcu-ask-link">
                      Pregúntale al profesor
                    </a>.
                  </p>
                </div>
                <StickyElement
                  v-if="examStatus !== 'passed'"
                  :sticky-class="'lcu-sticky-buttons'"
                  :sticky-threshold="40"
                  :release-threshold="80">
                  <div class="row lcu-sticky-buttons">
                    <div class="lcu-multiPage-grid lcu-exam-divider">
                        <div />
                        <div />
                        <div>
                          <button-cta
                            :text="'Enviar Examen'"
                            :loading="submitExamLoading"
                            :classes="['lcu-complete-btn']"
                            :disabled="!!examGrade || !allQuestionsAnswered"
                            @on-click="submitExam" />
                      </div>
                    </div>
                  </div>
                </StickyElement>
              </div>
            </div>
            <div
              class="row row-center"
              v-if="itemLoading">
              <spin-loader :size="'100px'" />
            </div>
          </div>
          <!-- Gated content due to billing issues -->
          <div
            class="lcu-active-paper lcu-paper-white"
            v-if="!itemError && !itemLoading && gatedForBilling">
            <div class="row row-center">
              <span class="lcu-gated-lock" />
              Para acceder a esta parte del programa, necesitarás pagar
              la siguiente cuota de tu plan de pagos.
            </div>
            <div class="lcu-program-installmentsHeader">
              <span>Cantidad</span>
              <span>Fecha de Vencimiento</span>
              <span>Estado</span>
            </div>
            <div
              class="lcu-program-installments"
              v-for="installment in installments"
              :key="installment.invoice">
              <span>{{ installment.readableAmount }}</span>
              <span>{{ installment.readableDueDate }}</span>
              <span>
                <component
                  :is="installment.invoiceUrl && installment.status === 'open' ? 'a' : 'span'"
                  class="lcu-bill-status"
                  :href="installment.status === 'open' && installment.invoiceUrl
                    ? installment.invoiceUrl
                    : null"
                  :target="installment.status === 'open' && installment.invoiceUrl
                    ? '_blank'
                    : null"
                  :rel="installment.status === 'open' && installment.invoiceUrl
                    ? 'noopener noreferrer'
                    : null"
                  :class="{
                    'lcu-bill-pastdue': isPastDue(installment),
                    'lcu-bill-paid': installment.status === 'paid',
                    'lcu-bill-ext': installment.invoiceUrl && installment.status === 'open'
                  }">
                  {{ getInvoiceStatus(installment) }}
                </component>
              </span>
            </div>
            <div class="lcu-bill-routeBtn">
              <button-cta
                :text="'Ir a Facturación'"
                :classes="['lcu-bill-btn']"
                border
                @on-click="$router.push({ path: '/cuenta/facturacion' })" />
            </div>
          </div>
          <!-- Error states -->
          <div class="lcu-item-error" v-if="itemError && !itemLoading && !completedMessage">
            <div class="row row-center">
              <img
                src="/assets/broken-page-primary.svg"
                class="lcu-item-brokenImg"
                alt="Programa no cargado" />
            </div>
            <p>{{ itemError }}</p>
            <button-cta
              :text="TRY_AGAIN"
              :loading="itemLoading"
              border
              @on-click="() => onModuleClick({
                module: activeModule,
                moduleItemNumber: meta[getLearnPrefData.lastViewed]
              })" />
          </div>
          <!-- Loader states -->
          <div class="lcu-active-paper" v-if="itemError && itemLoading">
            <div class="row row-center">
              <spin-loader :size="'100px'" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-center" v-if="programLoading || userLoading">
      <spin-loader :size="'100px'" />
    </div>
    <div v-if="programLoadError" class="row row-center">
      <div class="row">
        <img
          src="/assets/broken-page-primary.svg"
          class="lcu-program-brokenImg"
          alt="Programa no cargado" />
      </div>
      <p class="lcu-programLoad-error">
        {{ programLoadError }}
      </p>
      <button-cta
        :text="TRY_AGAIN"
        :loading="programLoading"
        border
        @on-click="getProgram" />
    </div>
  </div>
  <RetakeModal
    :is-open="confirmRetake"
    :onRetake="onRetake"
    :retakeError="retakeError"
    :loading="retakeLoading"
    @set-modal="setConfirmModal" />
  <ConfirmNextSection
    :is-open="confirmNextSection"
    :onConfirm="afterPassedExam"
    @set-modal="setNextModal" />
  <MediaPlayerModal
    :is-open="mediaPlayerOpen"
    :active-module="activeModule"
    @set-modal="setMediaPlayerModal" />
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import Announement from 'ç/announcement/Announcement.vue';
import Programs from '@/mixins/Programs.vue';
import { TRY_AGAIN } from '@/globals/constants';
import ButtonCta from 'ç/buttons/Cta.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import AudioPlayer from 'ç/audio-player/AudioPlayer.vue';
import StickyElement from 'ç/sticky-element/StickyElement.vue';
import RetakeModal from './RetakeModal.vue';
import ConfirmNextSection from './ConfirmNextSection.vue';
import MediaPlayerModal from './MediaPlayerModal.vue';
import SideBar from './Sidebar.vue';

const MODULE_LOAD_ERROR = 'Hubo un error al cargar este módulo. Por favor, inténtalo de nuevo.';

export default {
  name: 'registered-program',
  computed: {
    ...mapGetters(['user', 'userLoading']),
    allQuestionsAnswered() {
      const answered = Object.entries(
        this.activeExamAnswers,
        // eslint-disable-next-line no-unused-vars
      ).filter(([_, value]) => value !== false).length;
      const questions = (this.activeExam?.questions || []).length;
      return answered === questions;
    },
    getLearnPrefData() {
      const userProgram = this.user.programs[this.program?.slug] || {};
      if (userProgram.learnPreference === 'listen') {
        return {
          lastViewed: 'lastAudioViewed',
          highestViewed: 'highestAudioViewed',
          totalItems: 'totalAudio',
          type: 'Pista',
        };
      }
      if (userProgram.learnPreference === 'watch') {
        return {
          lastViewed: 'lastVideoViewed',
          highestViewed: 'highestVideoViewed',
          totalItems: 'totalVideo',
          type: 'Video',
        };
      }
      return {
        lastViewed: 'lastPageViewed',
        highestViewed: 'highestPageViewed',
        totalItems: 'totalPages',
        type: 'Página',
      };
    },
  },
  mixins: [Programs],
  components: {
    PageLegend,
    'program-side-bar': SideBar,
    'annoucement-banner': Announement,
    ButtonCta,
    SpinLoader,
    RetakeModal,
    ConfirmNextSection,
    MediaPlayerModal,
    StickyElement,
    AudioPlayer,
  },
  data() {
    return {
      TRY_AGAIN,
      itemLoading: false,
      itemError: false,
      currentItem: false,
      contentLoading: false,
      activeContent: false,
      activeMedia: false,
      activeModule: false,
      activeSection: false,
      completedMessage: false,
      gatedForBilling: false,
      installments: [],
      activeExam: false,
      activeExamAnswers: {},
      saveExamLoading: false,
      submitExamLoading: false,
      incorrect: {},
      retakeLoading: false,
      retakeError: false,
      examGrade: false,
      examStatus: false,
      confirmRetake: false,
      confirmNextSection: false,
      mediaPlayerOpen: false,
      meta: {
        lastAudioViewed: 1,
        highestAudioViewed: 1,
        totalAudio: 1,
        lastVideoViewed: 1,
        highestVideoViewed: 1,
        totalVideo: 1,
        lastPageViewed: 1,
        highestPageViewed: 1,
        totalPages: 1,
      },
    };
  },
  created() {
    this.authProgram();
  },
  watch: {
    userLoading(loading) {
      if (!loading) {
        this.authProgram();
      }
    },
  },
  methods: {
    async onAnswerSelect() {
      if (this.examGrade) {
        return;
      }
      this.saveExamLoading = true;
      try {
        const answers = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.activeExamAnswers).filter(([_, value]) => value !== false),
        );
        await this.$students({
          method: 'examAutoSave',
          payload: {
            slug: this.program.slug,
            moduleId: this.activeModule.id,
            sectionId: this.activeSection.id,
            answers,
          },
        });
      } catch (error) {
        this.$log.error(error || error.message);
      } finally {
        this.saveExamLoading = false;
      }
    },
    async onRetake() {
      this.retakeLoading = true;
      this.retakeError = false;
      try {
        const { userExamProgress } = await this.$students({
          method: 'retryExam',
          payload: {
            slug: this.program.slug,
            moduleId: this.activeModule.id,
            sectionId: this.activeSection.id,
          },
        });
        this.$log.info('New exam data: ', userExamProgress);
        this.incorrect = {};
        this.examStatus = false;
        this.examGrade = false;
        this.activeExamAnswers = {};
        this.confirmRetake = false;
      } catch (e) {
        this.$log.error(e.message || e);
        this.retakeError = 'Hubo un problema al intentar volver a realizar este examen. Por favor, inténtalo de nuevo más tarde.';
      } finally {
        this.retakeLoading = false;
      }
    },
    async submitExam() {
      if (this.examGrade) {
        return;
      }
      if (this.submitExamLoading) {
        return;
      }
      this.submitExamLoading = true;
      this.examFailed = false;
      this.examPassed = false;
      this.incorrect = {};
      try {
        const {
          status,
          incorrect,
          grade,
          programs,
        } = await this.$students({
          method: 'completeExam',
          payload: {
            slug: this.program.slug,
            moduleId: this.activeModule.id,
            sectionId: this.activeSection.id,
            answers: this.activeExamAnswers,
            examId: this.activeExam.id,
          },
        });
        this.incorrect = incorrect;
        this.examStatus = status;
        this.examGrade = grade;
        this.$log.info('submitExam | programs: ', programs);
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: 'programs',
          value: programs,
        });
        // Auto scroll to results when available
        setTimeout(() => {
          const resultsElement = document.getElementById('examResults');
          if (resultsElement) {
            resultsElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 300);
      } catch (e) {
        this.$log.error(e.message || e);
      } finally {
        this.submitExamLoading = false;
      }
    },
    async authProgram() {
      if (!this.user.id) {
        return;
      }
      await this.getProgram();
      // redirect to program landing page if student is nor registered
      if (!this.user.programs?.[this.program.slug]) {
        this.$router.push({ path: `/programas/${this.program.slug}` });
        return;
      }
      this.getProgress();
    },
    afterPassedExam() {
      this.confirmNextSection = false;
      this.activeExam = false;
      this.getProgress();
    },
    async getProgress() {
      this.itemLoading = true;
      try {
        const userProgram = this.user.programs[this.program.slug];
        const { progress } = userProgram;
        if (userProgram && userProgram.completed) {
          this.completedMessage = true;
          return;
        }
        // if user hasn't started yet
        if (typeof progress.lastModule === 'undefined') {
          const [firstSection] = this.program.sections;
          const [firstModule] = firstSection.modules;
          this.gatedForBilling = false;
          const {
            content,
            media,
            debug,
            invoices,
            gatedForBilling,
            programs,
          } = await this.$students({
            method: 'getProgramContent',
            payload: {
              slug: this.program.slug,
              moduleId: firstModule.id,
              moduleItemNumber: 1,
              sectionId: firstSection.id,
            },
          });
          this.$log.info('getProgress | programs: ', programs);
          this.$log.info('debug getProgress: ', debug);
          this.installments = invoices;
          if (content && !media) {
            this.activeContent = this.getURLContent(content);
          }
          if (media) {
            this.activeMedia = media;
          }
          const { totalItems } = this.getLearnPrefData;
          this.gatedForBilling = gatedForBilling;
          this.activeModule = firstModule;
          this.activeSection = firstSection;
          this.meta[totalItems] = firstModule.meta[totalItems];
        }
        if (progress.lastModule) {
          const { totalItems, lastViewed } = this.getLearnPrefData;
          this.gatedForBilling = false;
          const { module, section } = this.getModuleFromProgress(progress.lastModule);
          const {
            invoices,
            gatedForBilling,
            debug,
            content,
            media,
            exam,
            userExamProgress,
            programs,
          } = await this.$students({
            method: 'getProgramContent',
            payload: {
              slug: this.program.slug,
              moduleId: progress.lastModule,
              moduleItemNumber: progress[lastViewed],
              sectionId: section.id,
            },
          });
          this.$log.info('getProgress | programs: ', programs);
          this.$log.info('debug getProgress: ', debug);
          this.installments = invoices;
          if (content && !media) {
            this.activeContent = this.getURLContent(content);
          }
          if (media) {
            this.activeMedia = media;
          }
          if (exam && userExamProgress) {
            this.activeExam = exam;
            this.examGrade = userExamProgress.grade;
            this.examStatus = userExamProgress.status;
            this.incorrect = userExamProgress.incorrect;
            this.setActiveExamInputs({ exam, userExamAnswers: userExamProgress.answers });
          }
          this.gatedForBilling = gatedForBilling;
          this.activeModule = module;
          this.activeSection = section;
          this.meta[totalItems] = module.meta[totalItems];
          this.meta[lastViewed] = progress[lastViewed];
        }
        // check for progress of last place left off
        this.$log.info('getProgress: ', progress);
      } catch (e) {
        this.itemError = 'Ocurrió un error al cargar este elemento de la sección. Por favor, inténtalo de nuevo.';
        this.$log.error(e.message || e);
      } finally {
        this.itemLoading = false;
      }
    },
    setActiveExamInputs({ exam, userExamAnswers }) {
      exam.questions.forEach((question) => {
        this.activeExamAnswers[question.id] = userExamAnswers[question.id] || false;
      });
    },
    isPastDue(installment) {
      const today = moment().tz(this.user.timeZone);
      const dueDate = moment(installment.dueDate * 1000).tz(this.user.timeZone);
      return today.isAfter(dueDate) && installment.status !== 'paid';
    },
    getInvoiceStatus(installment) {
      if (this.isPastDue(installment)) {
        return 'past due';
      }
      if (installment.status === 'open') {
        return 'unpaid';
      }
      return installment.status;
    },
    getModuleFromProgress(id) {
      // this searches the user progress data and finds the module in the
      // program data to set an active module
      const { sections } = this.program;
      for (const section of sections) {
        for (const module of section.modules) {
          if (module.id === id) {
            return { module, section };
          }
        }
      }
      return {};
    },
    async onModuleClick({ module, moduleItemNumber = 1, section }) {
      this.itemError = false;
      if (module) {
        this.activeModule = module;
      } else {
        return;
      }
      if (section && section.id !== this.activeSection.id) {
        this.activeSection = section;
      }
      this.completedMessage = false;
      this.itemLoading = true;
      try {
        let p = moduleItemNumber;
        const program = this.user.programs[this.program.slug];
        const sec = program.sections[this.activeSection.id];
        const mod = sec && sec.modules[this.activeModule.id];
        const { totalItems, lastViewed } = this.getLearnPrefData;
        if (mod.progress && mod.progress[lastViewed]) {
          p = mod.progress[lastViewed];
          this.meta[lastViewed] = mod.progress[lastViewed];
        }
        // if (module.progress && module.progress[lastViewed]) {
        //   p = module.progress[lastViewed];
        //   this.meta[lastViewed] = module.progress[lastViewed];
        // }
        const { module: m } = this.getModuleFromProgress(module.id);
        if (m) {
          this.meta[totalItems] = m.meta[totalItems];
        }
        this.gatedForBilling = false;
        this.activeExam = false;
        const {
          invoices,
          gatedForBilling,
          debug,
          content,
          media,
          exam,
          userExamProgress,
        } = await this.$students({
          method: 'getProgramContent',
          payload: {
            slug: this.program.slug,
            moduleId: module.id,
            moduleItemNumber: p,
            sectionId: this.activeSection.id,
          },
        });
        this.$log.info('onModuleClick | getProgramContent: ', debug);
        this.installments = invoices;
        if (content && !media) {
          this.activeContent = this.getURLContent(content);
        }
        if (media) {
          this.activeMedia = media;
        }
        if (exam && userExamProgress) {
          this.activeExam = exam;
          this.examGrade = userExamProgress.grade;
          this.examStatus = userExamProgress.status;
          this.incorrect = userExamProgress.incorrect;
          this.setActiveExamInputs({ exam, userExamAnswers: userExamProgress.answers });
        }
        this.gatedForBilling = gatedForBilling;
      } catch (e) {
        this.itemError = MODULE_LOAD_ERROR;
        this.$log.error(e.message || e);
      } finally {
        this.itemLoading = false;
      }
    },
    // openBill(installment) {
    //   if (installment.invoiceUrl) {
    //     window.open(installment.invoiceUrl, '_blank', 'noopener,noreferrer');
    //   }
    // },
    async onBackPageClick() {
      const { lastViewed } = this.getLearnPrefData;
      const moduleItemNumber = this.meta[lastViewed] - 1;
      if (moduleItemNumber < 1) {
        return;
      }
      this.itemError = false;
      this.completedMessage = false;
      this.itemLoading = true;
      this.gatedForBilling = false;
      try {
        const {
          content,
          debug,
          invoices,
          media,
          gatedForBilling,
          exam,
          userExamProgress,
        } = await this.$students({
          method: 'getProgramContent',
          payload: {
            slug: this.program.slug,
            moduleId: this.activeModule.id,
            moduleItemNumber,
            sectionId: this.activeSection.id,
          },
        });
        this.$log.info('onBackPageClick | getProgramContent: ', debug);
        this.installments = invoices;
        if (content && !media) {
          this.activeContent = this.getURLContent(content);
        }
        if (media) {
          this.activeMedia = media;
        }
        if (exam && userExamProgress) {
          this.activeExam = exam;
          this.examGrade = userExamProgress.grade;
          this.examStatus = userExamProgress.status;
          this.incorrect = userExamProgress.incorrect;
          this.setActiveExamInputs({ exam, userExamAnswers: userExamProgress.answers });
        }
        this.gatedForBilling = gatedForBilling;
        this.meta[lastViewed] = moduleItemNumber;
      } catch (e) {
        this.itemError = MODULE_LOAD_ERROR;
        this.$log.error(e.message || e);
      } finally {
        this.itemLoading = false;
      }
    },
    async onNextPageClick() {
      this.itemError = false;
      this.itemLoading = true;
      try {
        const { totalItems, lastViewed } = this.getLearnPrefData;
        if (this.meta[lastViewed] + 1 > this.meta[totalItems]) {
          return;
        }
        this.completedMessage = false;
        const nextPage = this.meta[lastViewed] + 1;
        const { content, media, programs } = await this.$students({
          method: 'getNextModule',
          payload: {
            slug: this.program.slug,
            moduleId: this.activeModule.id,
            moduleItemNumber: nextPage,
            sectionId: this.activeSection.id,
          },
        });
        this.$log.info('onNextPageClick', programs);
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: 'programs',
          value: programs,
        });
        if (!media) {
          this.activeContent = this.getURLContent(content);
        } else {
          this.activeMedia = media;
        }
        this.meta[lastViewed] += 1;
      } catch (e) {
        this.itemError = MODULE_LOAD_ERROR;
        this.$log.error(e.message || e);
      } finally {
        this.itemLoading = false;
      }
    },
    async onCompleteClick() {
      this.itemError = false;
      this.itemLoading = true;
      try {
        if (this.activeModule.exam) {
          this.$log.info('onCompleteClick with exam');
          // This will only save the new exam status to the users data
          const completeModule = await this.$students({
            method: 'completeModule',
            payload: {
              slug: this.program.slug,
              moduleId: this.activeModule.id,
              sectionId: this.activeSection.id,
            },
          });
          this.$log.info('onCompleteClick | completeModule: ', completeModule);
          this.gatedForBilling = false;
          // This will grab the exam content
          const getProgramContent = await this.$students({
            method: 'getProgramContent',
            payload: {
              slug: this.program.slug,
              moduleId: this.activeModule.id,
              sectionId: this.activeSection.id,
            },
          });
          this.$log.info('onCompleteClick | getProgramContent: ', getProgramContent);
          if (getProgramContent.exam) {
            this.activeExam = getProgramContent.exam;
            this.examGrade = getProgramContent.userExamProgress.grade;
            this.examStatus = getProgramContent.userExamProgress.status;
            this.incorrect = getProgramContent.userExamProgress.incorrect;
            this.setActiveExamInputs({
              exam: getProgramContent.exam,
              userExamAnswers: getProgramContent.userExamProgress.answers,
            });
          }
        } else {
          const { programs, newModule, newSection } = await this.$students({
            method: 'completeModule',
            payload: {
              slug: this.program.slug,
              moduleId: this.activeModule.id,
              sectionId: this.activeSection.id,
            },
          });
          if (newModule) {
            this.activeModule = newModule;
            const { totalItems } = this.getLearnPrefData;
            this.meta[totalItems] = newModule.meta[totalItems];
          }
          if (newSection) {
            this.activeSection = newSection;
          }
          this.$log.info('onCompleteClick with no exam', programs);
          this.$store.dispatch('setGlobalValue', {
            item: this.user,
            key: 'programs',
            value: programs,
          });
          // If entire program is not completed on module completion, move to the
          // first moduleItemNumber
          if (!programs[this.program.slug].completed) {
            this.gatedForBilling = false;
            const {
              content,
              media,
              debug,
              invoices,
              gatedForBilling,
            } = await this.$students({
              method: 'getProgramContent',
              payload: {
                slug: this.program.slug,
                moduleId: this.activeModule.id,
                moduleItemNumber: 1,
              },
            });
            this.$log.info('onCompleteClick | getProgress: ', debug);
            this.installments = invoices;
            if (content && !media) {
              this.activeContent = this.getURLContent(content);
            }
            if (media) {
              this.activeMedia = media;
            }
            this.gatedForBilling = gatedForBilling;
            const { lastViewed } = this.getLearnPrefData;
            this.meta[lastViewed] = 1;
          } else {
            this.completedMessage = true;
          }
        }
      } catch (e) {
        this.itemError = 'Hubo un error al completar este módulo. Por favor, inténtalo de nuevo.';
        this.$log.error(e.message || e);
      } finally {
        this.itemLoading = false;
      }
    },
    getURLContent(content) {
      if (typeof content === 'string' && /^https?:\/\//i.test(content)) {
        return `${content}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
      }
      const blob = this.base64ToBlob(content, 'application/pdf');
      return `${URL.createObjectURL(blob)}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
    },
    base64ToBlob(base64, type = 'application/pdf') {
      const base64WithoutPrefix = base64.replace(/^data:application\/pdf;base64,/, '');
      const binStr = atob(base64WithoutPrefix);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      return new Blob([arr], { type });
    },
    checkLink(path) {
      if (!this.user.id) {
        this.loginModal = true;
        window.localStorage.setItem('lcuRequestedPath', path);
      } else {
        this.$router.push({ path });
      }
    },
    setConfirmModal(val) {
      this.confirmRetake = val;
    },
    setNextModal(val) {
      this.confirmNextSection = val;
    },
    setMediaPlayerModal(val) {
      this.mediaPlayerOpen = val;
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-program-section {
  display: flex;
  flex-direction: column;
  border-top: 1px solid $page-border;
  border-bottom: 1px solid $page-border;
}

.lcu-active-paper {
  padding: 20px;
}

.lcu-paper-white {
  background-color: $white;
  box-shadow: 0px 1px 10px 0px rgba($black, .12);
}

.lcu-program-grid {
  display: grid;
  grid-gap: 0;
  grid-template-columns: 300px 1fr;

  @media only screen and (max-width: $tablet-max) {
    grid-template-columns: 1fr;
  }
}

.lcu-active-section {
  background-color: $off-white;
  border: 1px solid rgba($white, .2);
  border-right: 0;
  padding: 20px;

  @media only screen and (max-width: $tablet-max) {
    border-bottom: 0;
    border-right: 1px solid rgba($white, .2);
  }
}

.lcu-item-error {
  text-align: center;
}

.lcu-active-error {
  padding: 50px;
  background-color: $white;
}

.lcu-item-brokenImg {
  width: 100px;
}

.lcu-embed-pdf {
  box-shadow: 0px 1px 10px 0px rgba($black, .12);
  width: 100%;
  height: 900px;
  border: 0;

  @media only screen and (max-width: $mobile-max) {
    height: 500px;
  }
}

.lcu-multiPage-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
}

.lcu-next-btn {
  padding-left: 35px;
  padding-right: 35px;
  justify-self: flex-end;
  display: flex;

  &::after {
    font-family: 'lcu';
    content: '\e80a';
    display: inline-block;
    margin-left: 5px;
  }
}

.lcu-complete-btn {
  background-color: $success;
  padding-left: 35px;
  padding-right: 35px;
  justify-self: flex-end;
  display: flex;
}

.lcu-prev-btn {
  padding-left: 35px;
  padding-right: 35px;
  justify-self: flex-start;
  display: flex;

  &::before {
    font-family: 'lcu';
    content: '\e81f';
    display: inline-block;
    margin-right: 5px;
  }
}

.lcu-completed-header {
  text-align: center;
  font-family: 'raleway-bold';
  font-size: 24px;
}

.lcu-complete-p {
  text-align: center;
}

.lcu-cert-image {
  text-align: center;
  img {
    width: 200px;
  }
}

.lcu-gated-lock {
  &:before {
    content: '\e81d';
    font-family: 'lcu';
    font-size: 64px;
    display: inline-block;
    margin: 25px 0;
  }
}

.lcu-program-installmentsHeader {
  display: grid;
  grid-template-columns: 10% 10% 10%;
  grid-gap: 30px;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid $page-border;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.lcu-program-installments {
  display: grid;
  grid-template-columns: 10% 10% 10%;
  grid-gap: 30px;
  justify-content: center;
  text-align: center;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: repeat(3, 1fr);
  }

  & > span {
    display: inline-block;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.lcu-bill-status {
  font-weight: bold;
  padding: 3px 6px 5px;
  color: #2f6290;
  background: #dcf1ff;
  border-radius: 4px;
  font-size: 13px;
}

.lcu-bill-pastdue {
  color: $danger;
  background: #ffe1e1;
}

.lcu-bill-paid {
  color: #1f8142;
  background: #d3fae4;
}

.lcu-bill-routeBtn {
  text-align: center;
  margin-top: 20px;
}

.lcu-bill-btn {
  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }
}

.lcu-exam-container {
  background-color: $white;
  padding: 35px;
  box-shadow: 0px 1px 10px 0px rgba($black, .12);
}

.lcu-exam-question {
  margin-bottom: 15px;
}

.lcu-exam-option {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-exam-divider {
  padding: 20px 0;
  border-top: 1px solid $page-border;
  margin-top: 20px;
}

.lcu-sticky-fixed {
  .lcu-exam-divider {
    padding: 0;
    border-top: 0;
    margin-top: 0;
  }
}

.lcu-question-wrapper {
  border: 1px solid $off-white;
  background-color: $white;
  border-radius: 3px;
  padding: 20px;
}

.lcu-question-wrong {
  border-color: $danger;
  background-color: #ffe4e4;
}

.lcu-failed-msg {
  color: $danger;
}

.lcu-exam-score {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 12px;
}

.lcu-exam-status {
  font-size: 21px;
}

.lcu-exam-passed {
  span {
    color: $success;
  }
}

.lcu-exam-failed {
  span {
    color: $danger;
  }
}

.lcu-media-header {
  margin-bottom: 20px;
}

.lcu-bill-ext {
  text-decoration: none;

  &:after {
    display: inline-block;
    margin-left: 5px;
    font-family: 'lcu';
    content: '\e82d';
    font-weight: normal;
    width: 10px;
  }
}

.lcu-audio-btn {
  border-width: 1px;
  font-weight: 500;
  padding: 10px 15px;

    &:after {
      display: inline-block;
      margin-left: 5px;
      font-family: 'lcu';
      content: '\e82c';
      font-weight: bold;
      width: 10px;
  }
}

.lcu-exam-statusWrapper {
  padding: 20px;
  border: 1px solid $page-border;
  background-color: $off-white;
}

.lcu-retake-btn {
  margin-top: 20px;
}

.lcu-ask-p {
  color: $gray-dark;
  margin-bottom: 0;
}

.lcu-ask-link {
  color: $legacy-primary;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}

.lcu-question-number {
  font-weight: bold;
  display: inline-block;
  margin-right: 5px;
}

.lcu-media-title {
  font-weight: bold;
  font-size: 21px;
}

.lcu-media-btn {
  justify-self: flex-end;
}
</style>
